import React from "react";
import "./WebsiteCMS.css";
import { Col, Container, Row } from "react-bootstrap";

function WebsiteCMS() {
  return (
    <section className="pb-lg-5 pt-4 margin-left">
      <Container fluid>
        <Row>
          <Col>
            {/* <div className="row"> */}
            <div className="dash-heading">
                      <h5 className="fw-bold text-black">
                      Website CMS
              </h5>
                <p>??</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WebsiteCMS;
